<template>
    <div class="infinite-scroll-container">sap</div>
</template>

<script>
export default {
    data() {
        return {
            videos: [], // Store your video URLs here
            isLoading: false,
        };
    },
    mounted() {
        console.log("wtf");
    },
    components: {},
};
</script>
